import { Modal, ModalProps } from 'components/common'

type CustomizedModalProps = Omit<
  ModalProps,
  'title' | 'okType' | 'okText' | 'okButtonProps' | 'cancelText'
>

export type DeleteConfirmationModalProps = CustomizedModalProps

export const DeleteConfirmationModal = ({
  ...rest
}: DeleteConfirmationModalProps): JSX.Element => (
  <>
    <Modal
      title={`料金表を削除しますか？`}
      okText={'料金表を削除する'}
      okType={'primary'}
      okButtonProps={{ danger: true }}
      cancelText={'キャンセル'}
      {...rest}
    >
      料金表を削除してもよろしいですか？ 削除後元に戻すことはできません。
    </Modal>
  </>
)
